import { render, staticRenderFns } from "./impact-form.vue?vue&type=template&id=a8e035a0&scoped=true&"
import script from "./impact-form.vue?vue&type=script&lang=js&"
export * from "./impact-form.vue?vue&type=script&lang=js&"
import style0 from "./impact-form.vue?vue&type=style&index=0&id=a8e035a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e035a0",
  null
  
)

export default component.exports